import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShellSesion } from '@intelishs-group/layout';
import { NotifyService } from '@intelishs-group/notify-service';
import { CalculosBarra } from '@components/calculos-barra/calculos-barra';
import { MARCA } from '../../app';

/**
 * El marco de SINAY (`<intelishs-shell-sesion>`, de `@intelishs-group/layout`) como RUTA PADRE de
 * todas las pantallas (`app.routes.ts`). La sesion la carga `proveerSesion` antes del primer render.
 *
 * Sin `[modulos]`: el menu son los MODULOS que identidad otorga al rol activo
 * (`SesionService.modulos()`), y el usuario, el selector de accesos, el cambio de sistema y la salida
 * de sesion los resuelve el marco, y tambien «Ir a…» (boton, Ctrl+K y su ventana; lo que busca son
 * las fuentes de `services/ir-a-fuentes.ts`, en `app.config.ts`). Aqui solo va la marca y, en la
 * barra, la pastilla de los calculos en marcha, directa al hueco con su `headerContent`.
 *
 * Es ruta padre y no un `@if (autenticado())` en `app.html` (2026-10-22, check de `sinay-audit`): con
 * el `@if` la sesion y el router deciden en momentos distintos y el marco parpadea al entrar y al
 * salir; como ruta, el router cambia el arbol de una sola vez y una ruta nueva queda protegida por
 * construccion.
 */
@Component({
  selector: 'app-marco',
  imports: [RouterOutlet, ShellSesion, CalculosBarra],
  template: `
    <intelishs-shell-sesion [marca]="marca" (fallo)="avisarFallo($event)">
      <app-calculos-barra headerContent />
      <router-outlet />
    </intelishs-shell-sesion>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Marco {
  private readonly notify = inject(NotifyService);

  protected readonly marca = MARCA;

  /** El marco no pudo cambiar de acceso (no avisa por su cuenta: emite el mensaje). */
  protected avisarFallo(mensaje: string): void {
    void this.notify.errorNotyfy(mensaje);
  }
}
